export default __webpack_public_path__ + "static/media/pETH.b43310ac.svg";